import type { StandardLonghandPropertiesHyphen } from 'csstype';

// Typescript does not have a numeric literal for NaN
type InvalidValues = false | '' | undefined | null;

export const buildCssProp = <K extends keyof StandardLonghandPropertiesHyphen>(
  propName: K,
  value: StandardLonghandPropertiesHyphen[K] | InvalidValues,
) => {
  if (!value && value !== 0) return '';
  return `${propName}: ${value}`;
};

export const buildCssLengthProp = <
  K extends keyof StandardLonghandPropertiesHyphen,
>(
  propName: K,
  length: StandardLonghandPropertiesHyphen[K] | InvalidValues | number,
) => {
  if (!length && length !== 0) return '';
  return `${propName}: ${length}${typeof length === 'number' ? 'px' : ''}`;
};

export const buildCssProps = (args: Parameters<typeof buildCssProp>[]) => args.map(arg => buildCssProp(...arg)).join(';\n');

export const buildCssLengthProps = (
  args: Parameters<typeof buildCssLengthProp>[],
) => args.map(arg => buildCssLengthProp(...arg)).join(';\n');

export default buildCssProp;
